// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/ssr/css/about.css);"]);
// Module
exports.push([module.id, "\n.container[data-v-792ed2f8] {\n  width: 100%;\n  min-height: 100vh;\n  background: #ffffff;\n}\n.main[data-v-792ed2f8] {\n  width: 100%;\n}\n.team-image-container[data-v-792ed2f8] {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto 60px;\n  padding: 0 var(--container-padding);\n}\n.team-photo[data-v-792ed2f8] {\n  width: 100%;\n  height: auto;\n  border-radius: 20px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\n}\n", ""]);
// Exports
module.exports = exports;
